export default {
	'文本描述': '文本描述',
	'单选': '单选',
	"多选": "多选",
	"填空": "填空",
	"问答": "问答",
	"量表": "量表",
	"矩阵单选": "矩阵单选",
	"矩阵多选": "矩阵多选",
	"矩阵量表": "矩阵量表",
	"排序": "排序",
	"表格填空": "表格填空",
	"附件上传": "附件上传",
  "附件":"附件",
	"表格下拉(单选)": "表格下拉(单选)",
	"表格下拉": "表格下拉",
	"定位": "定位",
	"划线": "划线",
	"矩阵限时判断": "矩阵限时判断",
	"日历": "日历",
	"满意度": '满意度',
	"认同度": '认同度',
	"重要度": '重要度',
	"愿意度": '愿意度',
	"符合度": '符合度',
	"自定义": '自定义',
	"自定义文字": '自定义文字',
	"默认": '默认',
	"滑块": '滑块',
	"大拇指": '大拇指',
	"笑脸": '笑脸',
	"星星": '星星',
	"笑脸哭脸": '笑脸/哭脸',
	"勾叉": '勾/叉',
	"满意": '满意',
	"认同": '认同',
	"重要": '重要',
	"愿意": '愿意',
	"符合": '符合',
  "手写签名":'手写签名',
  "联动":'联动',
  "标注":'标注'
}